import React, { Component } from 'react'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import './styles.scss';
import img1 from '../../assets/steca-logo.png'
import img2 from '../../assets/outback-logo.png'
import img3 from '../../assets/magnum-logo.png'
import img4 from '../../assets/cadsolar-logo.png'
import img5 from '../../assets/monbat-logo.png'
import img6 from '../../assets/franklin-logo.png'
import img7 from '../../assets/rollsbattery-logo.png'
import img8 from '../../assets/schneider-logo.png'
import img9 from '../../assets/victron-logo.png'
import img10 from '../../assets/suntech-logo.png'


export class SlickDemo extends Component {
    render() {
        var settings = {
            autoplay: true,
            autoplaySpeed: 2000,
            dots: true,
            infinite: true,
            speed: 500,
            centerMode: true,
            slidesToShow: 4,
            slidesToScroll: 1
        };
        return (
            <div>
                {/* <div class='container' >
                    <div className="row title" style={{ marginBottom: "20px" }} >
                        <div class="col-sm-12 btn btn-info">
                            Slick Carousel In React Application
                        </div>
                    </div>
                </div> */}
                <Slider {...settings} >
                    <div className="wdt">
                        <img className="img" src={img1} />
                    </div>
                    <div className="wdt">
                        <img className="img"  src={img2} />
                    </div>
                    <div className="wdt">
                        <img className="img" src={img3} />
                    </div>
                    <div className="wdt">
                        <img className="img" src={img4} />
                    </div >
                    <div className="wdt">
                        <img className="img" src={img5} />
                    </div>
                    <div className="wdt">
                        <img className="img" src={img6} />
                    </div>
                    <div className="wdt">
                        <img className="img" src={img7} />
                    </div>
                    <div className="wdt">
                        <img className="img" src={img8} />
                    </div>
                    <div className="wdt">
                        <img className="img" src={img9} />
                    </div>
                    <div className="wdt">
                        <img className="img" src={img10} />
                    </div>

                </Slider>
            </div>
        );
    }
}

export default SlickDemo